import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface Puppy {
  id: number;
  name: string;
  breed: string;
  age: string;
  gender: string;
  price: string;
  image: string;
  color: string;
  weight: string;
  available: boolean;
}

export default function FeaturedPuppies() {
  const [selectedBreed, setSelectedBreed] = useState<string>('all');
  const { t } = useTranslation();

  const puppies: Puppy[] = [
    {
      id: 1,
      name: 'Сеня',
      breed: 'Мальтипу',
      age: '2.5',
      gender: 'Female',
      price: '110.000 рублей.',
      color: 'Apricot',
      weight: '3.5 lbs',
      available: true,
      image: 'https://static.readdy.ai/image/f6d211637ce4f0c2a672f2f92ffb3ef8/39d93264511f136ab8f6f47e6e62b715.jpeg'
    },
    {
      id: 2,
      name: 'Пончик',
      breed: 'Maltipoo',
      age: '2.5',
      gender: 'Male',
      price: '90.000 рублей.',
      color: 'Рыжий',
      weight: '1кг',
      available: true,
      image: 'https://static.readdy.ai/image/f6d211637ce4f0c2a672f2f92ffb3ef8/f02b3f8fde89ff6b6eb0555692ed6969.jpeg'
    },
    {
      id: 3,
      name: 'Luna',
      breed: 'Toy Poodle',
      age: '2.5',
      gender: 'Male',
      price: '90.000 рублей.',
      color: 'Black',
      weight: '1кг',
      available: true,
      image: 'https://static.readdy.ai/image/f6d211637ce4f0c2a672f2f92ffb3ef8/2363839830fe497ea57d2e057e30dc61.jpeg'
    },
    {
      id: 4,
      name: 'Max',
      breed: 'Maltipoo',
      age: '2.5',
      gender: 'Male',
      price: '75.000 рублей.',
      color: 'Cream',
      weight: '1.5кг',
      available: true,
      image: 'https://static.readdy.ai/image/f6d211637ce4f0c2a672f2f92ffb3ef8/840fe27b83be0093a6340c2fca36c0a7.jpeg'
    },
    {
      id: 5,
      name: 'Daisy',
      breed: 'Toy Poodle',
      age: '2.5',
      gender: 'Female',
      price: '$2,900',
      color: 'Red',
      weight: '3 lbs',
      available: false,
      image: 'https://public.readdy.ai/ai/img_res/a82cfad0ae92bde6db10f16e06326296.jpg'
    },
    {
      id: 6,
      name: 'Cooper',
      breed: 'Miniature Poodle',
      age: '2.5',
      gender: 'Male',
      price: '$3,000',
      color: 'Brown',
      weight: '4.5 lbs',
      available: false,
      image: 'https://readdy.ai/api/search-image?query=Handsome%20brown%20miniature%20poodle%20puppy%20with%20thick%20curly%20coat%20sitting%20on%20white%20background%2C%20intelligent%20expression%2C%20professional%20studio%20pet%20photography%2C%20soft%20lighting%2C%20high%20quality%2C%20cute%20and%20confident%20look%2C%20simple%20clean%20background&width=600&height=600&seq=puppy-006&orientation=squarish'
    },
    {
      id: 7,
      name: 'Rosie',
      breed: 'Maltipoo',
      age: '2.5',
      gender: 'Female',
      price: '$2,700',
      color: 'Apricot',
      weight: '3.2 lbs',
      available: false,
      image: 'https://readdy.ai/api/search-image?query=Sweet%20apricot%20maltipoo%20puppy%20with%20soft%20wavy%20coat%20sitting%20on%20white%20background%2C%20adorable%20round%20eyes%2C%20tiny%20features%2C%20professional%20studio%20pet%20photography%2C%20bright%20lighting%2C%20high%20quality%2C%20extremely%20cute%20and%20lovable%2C%20clean%20simple%20background&width=600&height=600&seq=puppy-007&orientation=squarish'
    },
    {
      id: 8,
      name: 'Teddy',
      breed: 'Toy Poodle',
      age: '2.5',
      gender: 'Male',
      price: '$2,850',
      color: 'Silver',
      weight: '3.7 lbs',
      available: false,
      image: 'https://readdy.ai/api/search-image?query=Charming%20silver%20toy%20poodle%20puppy%20with%20fluffy%20curly%20coat%20sitting%20on%20white%20background%2C%20bright%20intelligent%20eyes%2C%20professional%20studio%20pet%20photography%2C%20soft%20lighting%2C%20high%20quality%2C%20adorable%20teddy%20bear%20appearance%2C%20simple%20clean%20background&width=600&height=600&seq=puppy-008&orientation=squarish'
    }
  ];

  const filteredPuppies = selectedBreed === 'all' 
    ? puppies 
    : puppies.filter(puppy => 
        selectedBreed === 'poodle' 
          ? puppy.breed.includes('Poodle')
          : puppy.breed === 'Maltipoo'
      );

  return (
    <section id="puppies" className="py-20 bg-gradient-to-b from-white via-pink-50/30 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {t('puppies.title')} <span className="bg-gradient-to-r from-pink-500 to-amber-400 bg-clip-text text-transparent">{t('puppies.titleHighlight')}</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            {t('puppies.subtitle')}
          </p>
        </div>

        <div className="flex justify-center mb-12">
          <div className="inline-flex bg-white rounded-full p-1 shadow-lg border border-pink-100">
            <button
              onClick={() => setSelectedBreed('all')}
              className={`px-6 py-2.5 rounded-full transition-all cursor-pointer whitespace-nowrap font-semibold ${
                selectedBreed === 'all'
                  ? 'bg-gradient-to-r from-pink-500 to-amber-400 text-white shadow-md'
                  : 'text-gray-600 hover:text-pink-500'
              }`}
            >
              {t('puppies.allPuppies')}
            </button>
            <button
              onClick={() => setSelectedBreed('poodle')}
              className={`px-6 py-2.5 rounded-full transition-all cursor-pointer whitespace-nowrap font-semibold ${
                selectedBreed === 'poodle'
                  ? 'bg-gradient-to-r from-pink-500 to-amber-400 text-white shadow-md'
                  : 'text-gray-600 hover:text-pink-500'
              }`}
            >
              {t('puppies.poodles')}
            </button>
            <button
              onClick={() => setSelectedBreed('maltipoo')}
              className={`px-6 py-2.5 rounded-full transition-all cursor-pointer whitespace-nowrap font-semibold ${
                selectedBreed === 'maltipoo'
                  ? 'bg-gradient-to-r from-pink-500 to-amber-400 text-white shadow-md'
                  : 'text-gray-600 hover:text-pink-500'
              }`}
            >
              {t('puppies.maltipoos')}
            </button>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-product-shop>
          {filteredPuppies.map((puppy) => (
            <div
              key={puppy.id}
              className="bg-white rounded-2xl shadow-xl overflow-hidden hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 cursor-pointer border border-pink-100"
            >
              <div className="relative h-64 overflow-hidden">
                <img
                  src={puppy.image}
                  alt={`${puppy.name} - ${puppy.breed}`}
                  className="w-full h-full object-cover object-top"
                />
                {puppy.available && (
                  <div className="absolute top-4 right-4 bg-gradient-to-r from-pink-500 to-amber-400 text-white px-3 py-1 rounded-full text-sm font-semibold shadow-lg">
                    {t('puppies.available')}
                  </div>
                )}
                {!puppy.available && (
                  <div className="absolute top-4 right-4 bg-gray-500 text-white px-3 py-1 rounded-full text-sm font-semibold shadow-lg">
                    {t('puppies.notAvailable')}
                  </div>
                )}
              </div>
              
              <div className="p-6">
                <div className="flex justify-between items-start mb-3">
                  <div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-1">{puppy.name}</h3>
                    <p className="text-pink-600 font-semibold">{puppy.breed}</p>
                  </div>
                  <div className="text-right">
                    <div className="text-2xl font-bold bg-gradient-to-r from-pink-500 to-amber-400 bg-clip-text text-transparent">{puppy.price}</div>
                  </div>
                </div>
                
                <div className="space-y-2 mb-4">
                  <div className="flex items-center text-gray-600">
                    <i className="ri-calendar-line w-5 h-5 flex items-center justify-center mr-2 text-pink-500"></i>
                    <span className="text-sm">{puppy.age} {t('puppies.age')}</span>
                  </div>
                  <div className="flex items-center text-gray-600">
                    <i className={`ri-${puppy.gender === 'Male' ? 'men' : 'women'}-line w-5 h-5 flex items-center justify-center mr-2 text-pink-500`}></i>
                    <span className="text-sm">{t(`puppies.${puppy.gender.toLowerCase()}`)}</span>
                  </div>
                  <div className="flex items-center text-gray-600">
                    <i className="ri-palette-line w-5 h-5 flex items-center justify-center mr-2 text-pink-500"></i>
                    <span className="text-sm">{puppy.color}</span>
                  </div>
                  <div className="flex items-center text-gray-600">
                    <i className="ri-scales-3-line w-5 h-5 flex items-center justify-center mr-2 text-pink-500"></i>
                    <span className="text-sm">{puppy.weight}</span>
                  </div>
                </div>
                
                <button className="w-full bg-gradient-to-r from-pink-500 to-pink-600 text-white py-3 rounded-full font-semibold hover:from-pink-600 hover:to-pink-700 transition-all shadow-lg cursor-pointer whitespace-nowrap">
                  {t('puppies.inquireNow')}
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
